import { useLocation } from "react-router-dom";

export default function Header() {

  const location = useLocation();

  const getTitle = () => {

    switch (location.pathname) {

      case "/admin/dashboard":
        return "Dashboard";

      case "/admin/users":
        return "Users";

      case "/admin/deposits":
        return "Deposits";

      case "/admin/investments":
        return "Investments";

      case "/admin/withdrawals":
        return "Withdrawals";

      case "/admin/level-income":
        return "Level Income";

      case "/admin/user-details":
        return "User Details";

      default:
        return "Admin Panel";
    }

  };

  return (

    <div
      style={{
        width: "100%",
        height: 70,
        background: "#ffffff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 30px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
      }}
    >

      <h2
        style={{
          margin: 0,
          color: "#111827"
        }}
      >
        {getTitle()}
      </h2>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 15
        }}
      >

        <span
          style={{
            fontWeight: "bold",
            color: "#374151"
          }}
        >
          Welcome Admin
        </span>

        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: "50%",
            background: "#2563eb",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            fontSize: 18
          }}
        >
          A
        </div>

      </div>

    </div>

  );

}
